import { Stack, Typography } from "@mui/material";
import { ClockOutlineIcon } from "../images/ClockOutlineIcon";

type Props = {
  seconds: number;
};

export const AnalysisTimeToastText = ({ seconds }: Props) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    width="100%"
  >
    <Typography
      sx={{
        color: "var(--text-default-body, #464646)",
        fontFamily: "Inter",
        fontSize: 14,
        fontWeight: 400,
        lineHeight: "22px",
        letterSpacing: "0.3px",
      }}
    >
      Approximate analysis time
    </Typography>
    <Stack
      direction="row"
      alignItems="center"
      gap="4px"
      sx={{
        color: "var(--Neutral-400, #797979)",
        fontFamily: "Inter",
        fontSize: 14,
        fontWeight: 400,
        lineHeight: "22px",
        letterSpacing: "0.3px",
      }}
    >
      <ClockOutlineIcon />~{Math.ceil(seconds / 60)} min
    </Stack>
  </Stack>
);
